import { createConfig } from "@fideus/react-config";
import { configSchema } from "./Config";

export * from "./Config";
export const { initConfig, getConfig, useConfig, ConfigProvider } =
  createConfig({
    schema: configSchema,
    configPath: "/config.json",
    versionPath: "/version",
  });
